export const GENRE_OPTIONS: DropdownOption<string>[] = [
  { value: '1', label: 'author.genres.fiction' },
  { value: '2', label: 'author.genres.poetry' },
  { value: '3', label: 'author.genres.drama' },
  { value: '4', label: 'author.genres.essay' },
  { value: '5', label: 'author.genres.graphic_novel' },
  { value: '6', label: 'author.genres.children' },
]
